export const getBreakpoints = () => ({
  xs: 304,
  sm: 768,
  md: 1280,
  lg: 1768,
  xl: 2160,
});
